import { app } from '../../app.module'
app
  // アカウントの投稿数グラフの表示
  .directive('accountTimePicker', () => {
    return {
      restrict: 'E',
      template: require('./account-time-picker.pug')(),
      controller: function ($scope, $state) {
        // 期間リスト
        $scope.periodTypes = ['月別', '曜日別', '日別', '時間帯別']
        $scope.periodType = $scope.periodTypes[0]

        // 分析画面の場合、デフォルトは日別にセット
        if ($state.current !== undefined && $state.current.name === 'analytics') {
          $scope.periodType = $scope.periodTypes[2]
        }

        // 期間を変更するイベント
        $scope.changePeriodType = function () {
          $scope.$emit('changePeriodType', $scope.periodType)
        }
      },
    }
  })
